import React from "react";
import BoostContainer from "pages/Boost/components/BoostContainer";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const config = [
  {
    section: "TomoBoost",
    items: [
      {
        question: () => "What is TomoBoost?",
        answer: () => (
          <p>
            TomoBoost is a product we developed to help increase credit scores
            FAST. We also enhance this process through analyzing successful
            recurring payments.
          </p>
        ),
      },
      {
        question: () => "I don't see rent showing up.",
        answer: () => (
          <p>
            Our rent identification system is now out! If you still do not see
            your rent transaction showing up, you can add it manually under the
            &quot;Don&apos;t See your Bills?&quot; section within your
            dashboard.
          </p>
        ),
      },
      {
        question: () => "What payments qualify for boosting my score?",
        answer: () => (
          <p>
            Any recurring bill qualifies: This means Utilities (water bill,
            electricity bill, cable, gas bill, etc). Subscriptions (Netflix,
            Hulu, Spotify, etc). But not limited to these! Gym memberships,
            Rent, Car Insurance payments, and more.
          </p>
        ),
      },
      {
        question: () => "What is Credit Reporting?",
        answer: () => (
          <p>
            Most people have more than one credit report. Credit reporting
            companies, also known as credit bureaus or consumer reporting
            agencies, collect and store financial data submitted by creditors,
            such as lenders, credit card companies, and other financial
            entities. Creditors aren’t required to report to every agency.
            Lenders use credit reports to decide whether to lend you money and
            at what interest rate. Other businesses might use your credit
            reports to determine whether to offer you insurance, rent a house or
            apartment to you, or provide you with cable TV, internet, utility, or
            cell phone service. If you agree to let an employer look at your
            credit report, it may influence their decision to hire you. The
            three major credit reporting agencies in the United States are
            Equifax, Experian, and TransUnion.
          </p>
        ),
      },
      {
        question: () => "How much will my credit score go up?",
        answer: () => (
          <p>
            This depends on multiple factors outside of TomoBoost; however we
            have had users boost over 150 points! Depending on your membership
            tier, you will see different levels of positive impact on your
            credit score.
          </p>
        ),
      },
      {
        question: () => "My personal information is wrong.",
        answer: () => (
          <p>
            Please reach out to customer support to update your personal
            information.
          </p>
        ),
      },
      {
        question: () => "My bank or account is not supported.",
        answer: () => (
          <p>
            We use Finicity, a Mastercard Company to securely and privately
            access your positive bill payments, and some banks or accounts may
            not be supported. Most of the time this is out of our control - but
            if you have any banks you would like for us to put in a request to
            add, please contact support.
          </p>
        ),
      },
    ],
  },
];

const FaqSection = ({ name }) => {
  return (
    <h3 className="pt-8 pb-3 text-3xl font-bold text-boost-purple-alt">
      {name}
    </h3>
  );
};

const FaqItem = ({ question, answer }) => {
  return (
    <div className="w-full px-1 mb-1">
      <div className="accordion_wrap_boost">
        <AccordionItem className="accordion_item_boost">
          <AccordionItemHeading className="accordion_item_heading_boost">
            <AccordionItemButton className="accordion_item_button_boost">
              {question?.()}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion_item_panel_boost text-white">
            {answer?.()}
          </AccordionItemPanel>
        </AccordionItem>
      </div>
    </div>
  );
};

const BoostFaq = () => {
  return (
    <BoostContainer relative>
      <div className="flex pt-32 lg:pt-24 text-white">
        <main className="w-full pt-16">
          <section className="mb-5 px-10 max-w-page text-center py-5 text-white">
            <h1 className="text-3xl md:text-5xl font-extrabold w-10/12 mx-auto">
              TomoBoost - Frequently Asked Questions
            </h1>
            <p className="md:text-2xl font-light mt-2 w-full md:w-8/12 mx-auto">
              Find answers to common questions.
            </p>
          </section>
          <section className="max-w-page">
            <div>
              <Accordion allowZeroExpanded>
                <div className="w-11/12 md:w-11/12 lg:w-8/12 mx-auto mb-20">
                  {config.map(({ section, items }) => {
                    return (
                      <div key="tomoboost-faq">
                        <FaqSection key={section} name={section} />
                        {items.map((item, i) => {
                          return (
                            <FaqItem
                              // eslint-disable-next-line react/no-array-index-key
                              key={`${section}-${i}`}
                              question={item?.question}
                              answer={item?.answer}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </Accordion>
            </div>
          </section>
        </main>
      </div>
    </BoostContainer>
  );
};

export default BoostFaq;
